module.exports = __webpack_public_path__ + "media/images/top/top_xs-c4e2307cb02e2a00ec5699e9f4d6a062.jpg";